"use strict";

exports.__esModule = true;

var _pageVisibility = require("./page-visibility");

exports.observePageVisibility = _pageVisibility.observePageVisibility;

var _pageClicks = require("./page-clicks");

exports.observePageClicks = _pageClicks.observePageClicks;